import { useEffect } from "react";

const APP_URL = "https://canhiresolution.com";
const DEFAULT_IMG = `${APP_URL}/canhiresolution-logo.png`;

function setTag(selector, attr, value) {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [type, name] = selector.replace("meta[", "").replace("]", "").split("=");
    el.setAttribute(type, name.replace(/"/g, ""));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel='${rel}']`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(data) {
  let el = document.head.querySelector("script[type='application/ld+json'][data-seo='1']");
  if (!el) {
    el = document.createElement("script");
    el.setAttribute("type", "application/ld+json");
    el.setAttribute("data-seo", "1");
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function useSEO({ title, description, image, path, jsonLd, type = "website" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · CanHireSolution.com` : "CanHireSolution.com — Hire Skilled Workers, Freelancers & Virtual Staff in Canada";
    document.title = fullTitle;

    const desc = description || "Canada's hiring platform for temp jobs, skilled trades, freelancers and virtual staff. Vetted talent — local or remote.";
    const img = image || DEFAULT_IMG;
    const url = path ? `${APP_URL}${path}` : (typeof window !== "undefined" ? window.location.href : APP_URL);

    setTag("meta[name='description']", "content", desc);
    setTag("meta[property='og:title']", "content", fullTitle);
    setTag("meta[property='og:description']", "content", desc);
    setTag("meta[property='og:image']", "content", img);
    setTag("meta[property='og:url']", "content", url);
    setTag("meta[property='og:type']", "content", type);
    setTag("meta[property='og:site_name']", "content", "CanHireSolution.com");
    setTag("meta[name='twitter:card']", "content", "summary_large_image");
    setTag("meta[name='twitter:title']", "content", fullTitle);
    setTag("meta[name='twitter:description']", "content", desc);
    setTag("meta[name='twitter:image']", "content", img);
    setLink("canonical", url);

    if (jsonLd) {
      setJsonLd(jsonLd);
    } else {
      setJsonLd({
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "CanHireSolution.com",
        url: APP_URL,
        potentialAction: {
          "@type": "SearchAction",
          target: `${APP_URL}/workers?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      });
    }
  }, [title, description, image, path, JSON.stringify(jsonLd), type]);
}
